import { useEffect, useRef } from 'react';
import { scrollToElement } from '@/util/utils';
export const useOldChatScroll = () => {
    const bodyRef = useRef(null);
    const messagesRef = useRef(null);
    useEffect(() => {
        const currentRef = messagesRef.current;
        const observer = new ResizeObserver(() => {
            if (bodyRef === null || bodyRef === void 0 ? void 0 : bodyRef.current) {
                scrollToElement(bodyRef.current, {
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
            }
        });
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [bodyRef, messagesRef]);
    return { bodyRef, messagesRef };
};
